export const sections = [
    {
        id: 'section-1',
        subtitle: 'RISUS LETANIE',
        title: 'MAGNA',
        description: 'Lectus dui mauris ultrices in turpis massa tincidunt. Odio aenean sed adipiscing diam. Tincidunt aliquam nulla facilisi cras fermentum vitae suscipit.',
        img:'https://cd1811c683c35eaa.demo.carrd.co/assets/images/container03.jpg',
        hasTwoButtons: false,
        selectors: ["#section-2"]
    },
    {
        id: 'section-2',
        subtitle: 'TELLUS MAURIS',
        title: 'URNA',
        description: 'Feugiat sed lectus vestibulum mattis. Congue nisi vitae suscipit tellus mauris a diam maecenas. Facilisis leo vel fringilla nulla ullamcorper.',
        img:'https://cd1811c683c35eaa.demo.carrd.co/assets/images/container04.jpg', 
        hasTwoButtons: true,
        selectors: ["#section-1", "#section-3"]
    },
    {
        id: 'section-3',
        subtitle: 'AUGUE MAURIS',
        title: 'AURORA',
        description: 'Neque gravida in fermentum sollicitudin. Elementum curabitur vitae nunc sed velit dignissim. Amet venenatis urna eget nunc scelerisque sed viverra.',
        img:'https://cd1811c683c35eaa.demo.carrd.co/assets/images/container01.jpg',
        hasTwoButtons: true,
        selectors: ["#section-2", "#section-4"]
    },
    {
        id: 'section-4',
        subtitle: 'HABITANT',
        title: 'FAMES',
        description: 'Tortor auctor urna nunc turpis nunc eget lorem dolor sed viverra ipsum. Ultrices sagittis orci a scelerisque purus semper aliquam eget duis.',
        img:'https://cd1811c683c35eaa.demo.carrd.co/assets/images/container02.jpg', 
        hasTwoButtons: true,
        selectors: ["#section-3", "#section-5"]
    },
    {
        id: 'section-5',
        subtitle: 'NULLA POSUERE',
        title: 'VITAE',
        description: 'Vitae auctor augue ut lectus bibendum nulla pellentesque dignissim enim. In habitasse platea in fermentum posuere urna mauris pharetra.',
        img:'https://cd1811c683c35eaa.demo.carrd.co/assets/images/container05.jpg', 
        hasTwoButtons: true,
        selectors: ["#section-4", "#section-6"]
    },
    {
        id: 'section-6',
        subtitle: 'SODALES ETIAM',
        title: 'LUCTUS',
        description: 'Sagittis consectetur purus ut faucibus pulvinar elementum integer enim. Facilisis gravida convallis a semper auctor nisl rhoncus mattis neque viverra.',
        img:'https://cd1811c683c35eaa.demo.carrd.co/assets/images/container06.jpg', 
        hasTwoButtons: false,
        selectors: ["#section-5"]
    }
  ]